import * as Yup from "yup";

import { STATUS } from "@/constant/statusConstants";

const getCurrencySchema = () =>
  Yup.object().shape({
    code: Yup.string()
      .label("ID")
      .required()
      .max(3),
    symbol: Yup.string()
      .label("Symbol")
      .required()
      .max(10),
    name: Yup.string()
      .label("Name")
      .required()
      .max(255),
    status: Yup
      .string()
      .label("Status")
      .required()
      .oneOf(Object.values(STATUS)),
  });

export default getCurrencySchema;
